var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2665",
    "data-name": "Group 2665",
    transform: "translate(-245 -349)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1254",
    "data-name": "Rectangle 1254",
    width: 24,
    height: 24,
    transform: "translate(245 349)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2015",
    "data-name": "Group 2015",
    transform: "translate(248.269 352.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M-4.184,0a7.529,7.529,0,0,1,1.7.194l.2,2.163a6.625,6.625,0,0,1,1.253.518L.65,1.491A7.56,7.56,0,0,1,1.99,2.558,7.5,7.5,0,0,1,3.056,3.9L1.671,5.573A6.643,6.643,0,0,1,2.19,6.828l2.163.2a7.561,7.561,0,0,1,0,3.4l-2.163.2a6.581,6.581,0,0,1-.519,1.253l1.385,1.675A7.558,7.558,0,0,1,.65,15.971l-1.675-1.383a6.625,6.625,0,0,1-1.253.519l-.2,2.163a7.529,7.529,0,0,1-1.7.194,7.535,7.535,0,0,1-1.7-.194l-.2-2.163a6.643,6.643,0,0,1-1.253-.519l-1.674,1.385a7.526,7.526,0,0,1-1.341-1.066,7.526,7.526,0,0,1-1.066-1.341l1.385-1.675a6.538,6.538,0,0,1-.519-1.253l-2.163-.2a7.534,7.534,0,0,1-.195-1.7,7.535,7.535,0,0,1,.193-1.7l2.163-.2a6.557,6.557,0,0,1,.519-1.253L-11.425,3.9a7.5,7.5,0,0,1,1.066-1.343A7.56,7.56,0,0,1-9.019,1.491l1.674,1.385a6.6,6.6,0,0,1,1.253-.518l.2-2.163A7.535,7.535,0,0,1-4.184,0Zm0,5.221A3.511,3.511,0,0,1-.673,8.733a3.515,3.515,0,0,1-3.511,3.511A3.511,3.511,0,0,1-7.7,8.733,3.511,3.511,0,0,1-4.184,5.221Z",
    transform: "translate(12.915 0)",
    fill: "none",
    stroke: "#15355c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.417
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.275bbe6d2abd598564f0ac55f4cf94c5.svg";
export { ForwardRef as ReactComponent };